import { useSyncExternalStore } from 'react'

/**
 * Los turnos de la agencia, para toda pantalla que ofrezca elegir uno o su ventana horaria.
 *
 * Cada pantalla tenía su lista fija —DAY, EVENING, NIGHT; 06–14, 14–22, 22–06— y un turno que la
 * agencia definiera en Administración no se podía publicar en Personal, ni planificar, ni entregar,
 * ni calcularle hotspots (hallazgos H-05 y H-06 de la prueba integral). La App los carga al entrar
 * y los vuelve a cargar cuando alguien los cambia.
 *
 * Mientras no llegan, las de fábrica: es lo que tiene toda agencia que nunca configuró los suyos,
 * y lo que el servidor usa en ese caso.
 */
export interface ShiftSpan { code: string; start: string; end: string }

const FABRICA: readonly ShiftSpan[] = [
  { code: 'DAY', start: '06:00', end: '14:00' },
  { code: 'EVENING', start: '14:00', end: '22:00' },
  { code: 'NIGHT', start: '22:00', end: '06:00' },
]

let codigos: readonly string[] = FABRICA.map((t) => t.code)
let ventanas: readonly string[] = ventanasDe(FABRICA)
const oyentes = new Set<() => void>()

/** La ventana de ATLAS de un turno, como la nombra el servidor: `11:00–15:00` → `11-15`. */
export function atlasWindow(t: ShiftSpan): string {
  return `${t.start.slice(0, 2)}-${t.end.slice(0, 2)}`
}

function ventanasDe(ts: readonly ShiftSpan[]): string[] {
  return ['ALL_DAY', ...new Set(ts.map(atlasWindow))]
}

export function setShiftTemplates(nuevas: readonly ShiftSpan[]): void {
  const plantillas = nuevas.length > 0 ? nuevas : FABRICA
  codigos = plantillas.map((t) => t.code)
  ventanas = ventanasDe(plantillas)
  oyentes.forEach((o) => o())
}

const suscribir = (o: () => void) => { oyentes.add(o); return () => { oyentes.delete(o) } }

export function useShiftCodes(): readonly string[] {
  return useSyncExternalStore(suscribir, () => codigos)
}

/** `ALL_DAY` y la ventana de cada turno de la agencia, sin repetir. */
export function useAtlasWindows(): readonly string[] {
  return useSyncExternalStore(suscribir, () => ventanas)
}
